class t{constructor(t){this.publicKey=t.publicKey,this.signature=t.signature,this.accountId=t.accountId}}export{t as default};
//# sourceMappingURL=SignerSignature.js.map
